/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
import { ErrorComponent } from '@ace-clublabs/payments-component-library';
import errorImage from '../assets/error_image.png';
import React, { useEffect } from 'react';
import CookieHelper from '../utils/cookieHelper';
import { useGlobalState } from '../shared/state';
import { ErrorType } from '../shared/types';
import { UtagHelper } from '../utils/utagHelper';
import { ClubHelper } from '@ace-clublabs/payments-helper';
import Header from '../components/Header';
import { Button } from '@ace-clublabs/shared-component-library';
import { getPaymentPBLTaggingFlow, getPaymentPBLTaggingInsurancePolicies } from '../utils/methods';

const ErrorPage: React.FC = () => {
  const clubCode = CookieHelper.getClubCodeFromZipcodeCookie();
  const [sessionId] = useGlobalState('sessionId');
  const [customerId] = useGlobalState('customerId');
  const [payByLinkData] = useGlobalState('payByLinkData');
  const [error] = useGlobalState('error');
  const [manifest] = useGlobalState('manifest');
  const [paymentProcessing] = useGlobalState('paymentProcessing');

  const isSMSFlow: boolean = (!!payByLinkData && !!customerId && !!sessionId) || error?.errorType === ErrorType.PBL_EXPIRED;
  const smsPaymentError = isSMSFlow && paymentProcessing;

  useEffect(() => {
    if (isSMSFlow) {
      const products = payByLinkData?.products || [];
      const productTypes = products.map((product: any) => {
        const productType = product.productType?.toLowerCase();
        const productSubType = product.productSubType?.toLowerCase();

        if (productType === 'insurance') {
          return productSubType === 'auto'
            ? 'auto insurance'
            : productSubType === 'home'
              ? 'home insurance'
              : `${productSubType} insurance`;
        }
        return productType === 'membership' ? 'membership' : productType;
      });
      const flow = getPaymentPBLTaggingFlow(payByLinkData);
      const insurancePolicies = getPaymentPBLTaggingInsurancePolicies(payByLinkData);

      let tagError = undefined;
      if (error?.errorType === ErrorType.PBL_EXPIRED) {
        tagError = 'my account:sms:error-payment link expired';
      } else if (error?.errorType === ErrorType.PBL_ERROR) {
        tagError = 'my account:sms:error-payment failed';
      }

      UtagHelper.tag({
        channel: 'my account',
        custID: customerId,
        error: tagError,
        flow: flow,
        ins_policy: insurancePolicies,
        page: 'my account:sms:error',
        sessionid: sessionId,
        subchannel1: 'sms',
      });
    } else {
      if (error?.errorType === ErrorType.SESSION_TIMEOUT || !manifest?.tags) {
        UtagHelper.tag({
          channel: 'error',
          page: 'error-session timeout',
          error: 'error-session timeout',
          sessionid: sessionId,
        });
      } else {
        const errorTag = UtagHelper.tagError(manifest?.tags, 'payment error', 'payment error-system error');
        UtagHelper.tag({ ...errorTag, sessionid: sessionId });
      }
    }
  }, [customerId, sessionId, error, manifest, payByLinkData]);

  const phoneNumber = ClubHelper.getClubPhoneNumber(clubCode);
  let overrideText;

  const errorMessage = () => {
    switch (error?.errorType) {
      case ErrorType.SESSION_TIMEOUT:
        return 'This session has expired or cannot be located. Please try again';
      case ErrorType.MANIFEST_ERROR:
        return error?.errorMessage;
      case ErrorType.PBL_EXPIRED:
        overrideText = 'Please contact us for a new link.';
        return 'Your payment link has expired';
      case ErrorType.RATE_LIMITED:
        overrideText = 'Please wait a moment before trying again.';
        return 'Too many payment attempts';
      default:
        overrideText = 'Please try again later or contact us for assistance.';
        return smsPaymentError
          ? 'Sorry, there was a problem processing your payment'
          : 'Our systems are temporarily unavailable';
    }
  };

  const displayBranchButton =
    ![ErrorType.MANIFEST_ERROR, ErrorType.PBL_EXPIRED, ErrorType.PBL_ERROR, undefined].includes(error?.errorType!) &&
    !smsPaymentError;

  return (
    <div className="inner-container error-page-container">
      <Header />
      <ErrorComponent
        imagePath={errorImage}
        phoneNumber={isSMSFlow ? '1-877-428-2277' : phoneNumber}
        customerServiceHours={isSMSFlow ? ['Monday-Friday: 7 a.m. to 7 p.m.', 'Saturday: 8 a.m. to 5 p.m.'] : undefined}
        title={errorMessage()}
        overrideText={overrideText}
      />
      {displayBranchButton && (
        <Button
          fullWidth
          variant="contained"
          label="See nearest branches"
          className="need-help-button"
          onClick={() => window.open('https://aaa.com/office', '_blank')}
        ></Button>
      )}
    </div>
  );
};

export default ErrorPage;